export const agentNameStorageKey = 'chatAgentName';
export const startChatDetailsStorageKey = 'chatDetails';
export const chatMessagesStorageKey = 'chatMessages';
export const timestampStorageKey = 'chatTimestamp';
//# sourceMappingURL=liveChat.js.map